import { IconButton, Image } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const GiftExperiencePreview = styled.div`
  display: flex;
  flex: 0.8;
  justify-content: center;
`;

const GiftExperiencePreviewWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  margin-top: -16px;
  padding-top: 16px;
  position: fixed;
  transform-origin: top center;

  @media (min-height: 1100px) {
    scale: 1.2;
  }

  @media (max-height: 880px) {
    scale: 0.9;
  }

  @media (max-height: 800px) {
    scale: 0.8;
  }

  @media (max-height: 750px) {
    scale: 0.7;
  }

  @media (max-height: 700px) {
    scale: 0.65;
  }

  @media (max-height: 650px) {
    scale: 0.6;
  }

  ${IconButton.S.IconButton} {
    scale: 1.5;
  }
`;

const Dot = styled(Image)`
  opacity: ${({ active }) => (active ? '1' : '.5')};
`;

const PhoneColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const DotWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
`;

const PhonePreview = styled.div(
  ({ theme: { images } }) => css`
    background: url(${images.iphoneImage}) no-repeat center center;
    background-size: 500px 550px;
    display: flex;
    flex: unset;
    flex-direction: column;
    height: 550px;
    overflow: hidden;
    padding-bottom: 20px;
    padding-left: 32px;
    padding-right: 30px;
    position: relative;
    width: 300px;
  `
);

export {
  Dot,
  DotWrapper,
  GiftExperiencePreview,
  GiftExperiencePreviewWrapper,
  PhoneColumn,
  PhonePreview
};
